
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/konec-lyzarske-sezony-predpoklad",
      function () {
        return require("private-next-pages/[region]/konec-lyzarske-sezony-predpoklad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/konec-lyzarske-sezony-predpoklad"])
      });
    }
  